<template>
  <v-card flat class="next-steps-card">
    <v-card-title v-if="buyerExpressedInterest">
      Your Application Is Submitted
    </v-card-title>

    <v-card-title v-else-if="completedBuyerProfile">
      Express Interest On Listing:
    </v-card-title>

    <v-card-title v-else>
      Next Steps:
    </v-card-title>

    <v-card-text v-if="buyerExpressedInterest">
      <p>
        Our team will reach out to you to update you on next steps and statusof the listing. Timelines vary depending on the listing. You can check your status or the listing status below or by using the "Manage Your Deals" button above.
      </p>

      <v-btn 
        outlined 
        color="primary"
        @click="openQuickViewDeals">
        View Listing Status
      </v-btn>
    </v-card-text>

    <v-card-text v-else-if="completedBuyerProfile">
      <p>
        Express interest to become a buyer for this practice. We’ll review your application and reach out with next steps within 3 business days.
      </p>

      <v-btn 
        depressed 
        class="express-interest-btn"
        @click="triggerExpressInterest">
        Express Interest
      </v-btn>
    </v-card-text>

    <v-card-text v-else>
      <p>
        Complete the buyer profile to be notified first when a new listing is published and express interest on seller listings.
      </p>

      <v-btn
        :to="`/module_questionnaire/${moduleKey}`"
        depressed class="complete-profile-btn">
        Complete Buyer Profile
      </v-btn>
    </v-card-text>

    <v-card-actions>
      <a
        :href="`mailto:${email}`"
        @click.prevent="askQuestion">
        Ask a Question
      </a>
      <a href="tel:5034279910">(503) 427-9910</a>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'BuyerListingDetailsNextSteps',
  props: {
    moduleKey: String,
    listingId: String,
    completedBuyerProfile: Boolean,
    buyerExpressedInterest: Boolean,
    update: Function,
    quickViewDeals: Boolean
  },

  data: () => ({
    email: 'listings@successionresourcegroup.com',
  }),
  methods: {
    askQuestion () {
      const link = '' +
        `mailto:${this.email}` +
        '?subject=' + encodeURIComponent(`Question about Listing ${this.listingId}`)

      window.open(link)
    },

    triggerExpressInterest () {
      this.$emit('update')
    },

    openQuickViewDeals () {
      this.$emit('quickViewDeals', !this.quickViewDeals)
    }
  }
}
</script>

<style scoped>
.next-steps-card {
  border-bottom: 2px solid #C7C7C7;
}

.next-steps-card .v-card__title {
  color: #5F6062;
  font-family: "SansationBold", sans-serif;
  font-size: 20px;
}

.next-steps-card .v-card__text {
  display: flex;
  flex-direction: column;
  align-items: center;

  color: #5F6062;
}

.next-steps-card .v-btn {
  width: 260px;
  max-width: 95%;

  font-family: 'SansationBold', sans-serif;
  font-size: 14px;
}

.next-steps-card .v-btn.express-interest-btn {
  background-color: #97C131 !important;
  color: #FFFFFF;
}

.next-steps-card .v-btn.complete-profile-btn {
  border: 1px solid #D6D6D6;
  background-color: #E6E7E8 !important;
  color: #5F6062;
}

.next-steps-card .v-card__actions {
  justify-content: center;
}

.next-steps-card .v-card__actions a {
  position: relative;

  flex-grow: 1;
  display: block;
  margin: 0 5px;
  padding: 5px 10px;

  color: #0096A6;
  text-align: center;
  text-decoration: none;
}

.next-steps-card .v-card__actions a:first-child::after {
  content: '';

  position: absolute;
  top: 15%;
  bottom: 15%;
  right: -5px;
  width: 2px;

  background-color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/next-steps.vue